const button = {
  changeStyle: 'Change Style',
};

export default {
  button,
};
